// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3PkOu","footer":"ReportModalFilter_footer__2TUsm"};